/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkipBackIcon32Regular = forwardRef('MediaUiASkipBackIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 6a1 1 0 0 1 2 0v9.856a2.478 2.478 0 0 1 1.13-1.95l13.004-8.48C23.797 4.34 26 5.533 26 7.518v16.962c0 1.985-2.203 3.178-3.866 2.094L9.13 18.095A2.478 2.478 0 0 1 8 16.144V26a1 1 0 1 1-2 0V6Zm18 1.52a.5.5 0 0 0-.773-.42l-13.004 8.481a.5.5 0 0 0 0 .838l13.004 8.48a.5.5 0 0 0 .773-.418V7.519Z" })));
});
